import api from "./api";

function authHeaders() {
  const token = localStorage.getItem("tk446655440000");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export const EMPTY_ESTABLISHMENT_FILTERS = Object.freeze({
  type: "",
  status: "",
});

export function compactEstablishmentFilters(filters = {}) {
  const params = {};
  ["type", "status"].forEach((key) => {
    const value = String(filters[key] ?? "").trim();
    if (value) params[key] = value;
  });
  return params;
}

function uniqueValues(values = []) {
  const seen = new Set();
  return (Array.isArray(values) ? values : []).reduce((result, raw) => {
    const value = String(raw ?? "").trim();
    const key = value
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLocaleLowerCase("fr");
    if (!value || seen.has(key)) return result;
    seen.add(key);
    result.push(value);
    return result;
  }, []);
}

export function establishmentTypeOptions(t, values = []) {
  return [
    { id: "", text: t ? t("establishments.filter.all_types", "Tous les types") : "Tous les types" },
    ...uniqueValues(values).map((value) => ({ id: value, text: value })),
  ];
}

export function establishmentStatusOptions(t, values = []) {
  return [
    { id: "", text: t ? t("establishments.filter.all_statuses", "Tous les statuts") : "Tous les statuts" },
    ...uniqueValues(values).map((value) => ({ id: value, text: value })),
  ];
}

export function buildEstablishmentFilterOptionParams(filters = {}) {
  const params = {};
  ["provinceId", "departmentId", "subPrefectureId"].forEach((key) => {
    const value = Number(filters[key]);
    if (Number.isFinite(value) && value > 0) params[key] = value;
  });
  return params;
}

export function parseEstablishmentFilterOptions(data) {
  return {
    types: uniqueValues(data?.types ?? data?.Types),
    statuses: uniqueValues(data?.statuses ?? data?.Statuses),
  };
}

export async function fetchEstablishmentFilterOptions(filters = {}, signal) {
  const { data } = await api.get("/Assignment/establishment-filter-options", {
    params: buildEstablishmentFilterOptionParams(filters),
    headers: authHeaders(),
    signal,
  });
  return parseEstablishmentFilterOptions(data);
}

export function buildAssignmentEstablishmentParams(sptid, filters = {}) {
  return {
    sptid,
    ...compactEstablishmentFilters(filters),
  };
}

export function buildAssignmentCreationEntries(values, forceReassignment) {
  return [
    ["AsignId", values.teachers],
    ["EstabId", values.establishment],
    ["AssigDateTime", values.date],
    ["ForceReassignment", String(forceReassignment)],
  ];
}
